module.exports = __webpack_public_path__ + "media/images/ui__textArrowDown-861b5b49d4f62f5c208a9b628ea53548.png";